;(function (angular, _, Audio, Pusher) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('NotificationService', NotificationService)

  NotificationService.$inject = [
    // Urls
    'urls',

    // Auth
    'zlAuth',

    // App Id
    'appId',

    // Angular
    '$rootScope',

    // Services
    'SnackService', 'SessionService',

    // Managers
    'NotificationManager',

    // Pusher
    '$pusher', 'pusherAPI'

  ]

  /**
   * Constructor
   * This service handles
   *  - The live notifications received via socket
   *  - The notification objects via $http queries.
   *
   */
  function NotificationService (
    // Urls
    urls,

    // Auth
    zlAuth,

    // App Id
    appId,

    // Angular
    $rootScope,

    // Services
    SnackService, SessionService,

    // Managers
    NotificationManager,

    // Pusher
    $pusher, pusherAPI

  ) {
    var self = this

    self.notifications = []
    self.allnotifications = []
    var pusher

    var audio = new Audio('/assets/sounds/notify-1.mp3')

    refreshNotifications()

    /**
     * Suscribe to $socket notifications.
     * $socket url is set in config.yaml
     */
    zlAuth.getToken().then(function (token) {
      initPusher(token)
    })

    zlAuth.registerObserver(self)

    function initPusher (token) {
      window.pusherClient = new Pusher(pusherAPI, {
        cluster: 'eu',
        disableStats: true,
        authEndpoint: urls.socketnotif,
        auth: {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        }
      })
      pusher = $pusher(window.pusherClient)

      // Channel vars
      var application = atob(appId) + '-'
      var userId = SessionService.getUser() + '-'
      var company = SessionService.getCompany()

      // Susbscribe to a private channel
      var channel = pusher.subscribe('private-' + application + userId + company)
      var companyChannel = pusher.subscribe('private-' + application + company)
      var publicChannel = pusher.subscribe(atob(appId))

      publicChannel.bind('broadcast', function (data) {
        SnackService.snack({
          text: data.message,
          delay: 5000
        })
      })

      companyChannel.bind('notification', function (data) {
        switch (data.event) {
          case 'updateInvoiceMessage':
          case 'updateInvoiceHistory':
            $rootScope.$broadcast(data.event, data.invoice)
          case 'updateQuoteMessage':
          case 'updateQuoteHistory':
            $rootScope.$broadcast(data.event, data.quote)
        }
      })

      // Listen notification event in this private channel
      channel.bind('notification', function (data) {
        // Make magic here!
        refreshNotifications()
        var message
        var action
        // noinspection FallThroughInSwitchStatementJS
        // If the event is about an intervention, broadcast an event, so that concerned states reload themselves
        switch (data.event) {
          case 'updateIntervention':
            $rootScope.$broadcast('updateIntervention', data.intervention)
            return
          case 'completeIntervention':
            message = 'Intervention terminée'
            action = 'interventions.show({id:"' + data.intervention + '"})'
            $rootScope.$broadcast('updateIntervention', data.intervention)
            break
          case 'completeInterventionWithProblems':
            message = message || 'Intervention terminée avec problèmes'
            action = 'interventions.show({id:"' + data.intervention + '"})'
            $rootScope.$broadcast('updateIntervention', data.intervention)
            break
          case 'startIntervention':
            message = message || 'Intervention en cours'
            action = 'interventions.show({id:"' + data.intervention + '"})'
            $rootScope.$broadcast('updateIntervention', data.intervention)
            break
          case 'startInterventionTravel':
            message = 'Trajet démarré'
            action = 'interventions.show({id:"' + data.intervention + '"})'
            $rootScope.$broadcast('updateIntervention', data.intervention)
            break
          case 'ArchiveCreated':
            message = 'Export fichier ZIP terminé'
            action = '.'
            break
          case 'excelCreated':
            message = 'Export(s) tableur terminé(s)'
            action = '.'
            break
          case 'PDFsCreated':
            message = 'Export(s) PDF terminé(s)'
            action = '.'
            break
          case 'FacturXCreated':
            message = 'Export(s) Factur-X terminé(s)'
            action = '.'
            break
          case 'newInmail':
            message = 'Nouveau Signalement'
            action = 'inbox.show({id:"' + data.inmail + '"})'
            break
          case 'refererOrder':
            message = 'Vous avez été assigné à une affaire'
            action = 'orders.show({id:"' + data.order + '"})'
            break
          case 'refererInvoice':
            message = 'Vous avez été assigné à une facture'
            action = 'invoice.show({id:"' + data.invoice + '"})'
            break
          case 'bulkInvoiceValidation':
            message = 'Validation de facture terminée'
            action = '.'
            $rootScope.$broadcast('InvoiceBulkValidate')
            break
          case 'bulkQuoteValidation':
            message = 'Validation de devis terminée'
            action = '.'
            $rootScope.$broadcast('QuoteBulkValidate')
            break
          case 'bulkCreditNoteValidation':
            message = "Validation d'avoir terminée"
            action = '.'
            $rootScope.$broadcast('CreditNoteBulkValidate')
            break
          case 'bulkOrderValidation':
            message = 'Validation de chantier terminée'
            action = '.'
            $rootScope.$broadcast('OrderBulkValidate')
            break
          case 'bulkInvoiceStatus':
            message = 'Changements de statuts de facture terminés'
            action = '.'
            $rootScope.$broadcast('InvoiceBulkStatus')
            break
          default:
            return
        }
        SnackService.snack({
          text: message,
          delay: 10000,
          action: action,
          actionText: action === '.' ? '' : 'Voir'
        })
        audio.play()
      })
    }

    function refreshPusher () {
      if (pusher && pusher.disconnect) {
        pusher.disconnect()
      }
      zlAuth.getToken().then(function (token) {
        initPusher(token)
      })
    }

    /**
     * Returns true if there are unread notifications
     * @returns {boolean}
     */
    function newNotif () {
      return !!(self.notifications && !_.every(self.notifications, 'isRead'))
    }

    /**
     * Queries for unread notifications.
     * This will also query for interventions if need be
     */
    function refreshNotifications () {
      if (self.refrechNotif) {
        clearTimeout(self.refrechNotif)
      }
      self.refrechNotif = setTimeout(function () {
        NotificationManager.get(NotificationManager.query({ conditions: { isRead: false } })).then(function (data) {
          self.notifications = data.data
        })
        NotificationManager.get(NotificationManager.query().paginate({ limit: 80 })).then(function (data) {
          self.allnotifications = data.data
        })
      }, 1000)
    }

    /**
     * Mark all notifications as read
     * @returns {Promise}
     */
    function markAllAsRead () {
      return NotificationManager.markAsRead(_.map(self.allnotifications, '_id')).then(refreshNotifications)
    }

    /**
     * Return the count of notification
     * @returns {string} - The number of unread notifications beetween brackets to display
     */
    function countNotifications () {
      if (self.notifications.length) {
        return '(' + self.notifications.length + ') '
      }
    }

    /**
     * Return all notification
     * @returns {*|Array}
     */
    function getAllNotifications () {
      return self.allnotifications
    }

    /**
     * Return notification
     * @returns {Array|*}
     */
    function getNotifications () {
      return self.notifications
    }

    //
    _.extend(self, {
      refreshNotifications: refreshNotifications,
      getNotifications: getNotifications,
      getAllNotifications: getAllNotifications,
      newNotif: newNotif,
      countNotifications: countNotifications,
      markAllAsRead: markAllAsRead,
      notifyAuthChange: refreshPusher
    })
  }
})(window.angular, window._, window.Audio, window.Pusher)
